/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IInstitution } from 'app/shared/model/institution.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IHospitalInstitution {
  id?: string;
  accountHolderName?: string | null;
  accountNo?: string | null;
  ifscCode?: string | null;
  allowedCredit?: number | null;
  maxCreditLimit?: number | null;
  standardCreditLimit?: number | null;
  openingBalance?: number | null;
  overDraft?: boolean | null;
  inactive?: boolean | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  institution?: IInstitution | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IHospitalInstitution> = {
  overDraft: false,
  inactive: false,
  active: false,
};
